// Browser errors -> POST /api/client-errors (our own server; grouped in God's Eye → Errors). At most 20 reports per
// page load and one per distinct message a minute; never throws.
const API = process.env.REACT_APP_API_BASE || 'http://localhost:5000';
let sent = 0;
const recent = new Map();

function bundleVersion() {
  const s = [...document.scripts].map((x) => x.src).find((src) => /\/static\/js\/main\.[0-9a-f]+\.js/.test(src));
  return s ? (s.match(/main\.([0-9a-f]+)\.js/) || [])[1] : 'dev';
}

export function reportClientError(kind, message, stack) {
  try {
    const msg = String(message || '').slice(0, 2000);
    if (!msg || sent >= 20) return;
    const now = Date.now();
    if (now - (recent.get(msg) || 0) < 60000) return;
    recent.set(msg, now);
    sent += 1;
    const token = localStorage.getItem('token');
    fetch(`${API}/api/client-errors`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
      body: JSON.stringify({ kind, message: msg, stack: String(stack || '').slice(0, 20000), page: window.location.pathname, version: bundleVersion() }),
      keepalive: true,
    }).catch(() => {});
  } catch (_) { /* never */ }
}

export function installClientErrors() {
  if (typeof window === 'undefined' || window.__nmErrors) return;
  window.__nmErrors = true;
  window.addEventListener('error', (e) => {
    if (!e || (!e.error && !e.message)) return;
    reportClientError(e.error?.name || 'Error', e.error?.message || e.message, e.error?.stack || `${e.filename}:${e.lineno}:${e.colno}`);
  });
  window.addEventListener('unhandledrejection', (e) => {
    const r = e && e.reason;
    if (!r) return;
    if (r.isAxiosError || r.name === 'AxiosError' || r.name === 'CanceledError' || r.name === 'AbortError') return; // network noise, seen server-side
    reportClientError(r.name || 'UnhandledRejection', r.message || String(r), r.stack);
  });
}
